import {
  Bookmark16Regular,
  Bookmark24Regular,
  Cloud16Regular,
  Cloud24Regular,
  Database16Regular,
  Database24Regular,
  Desktop16Regular,
  Desktop24Regular,
  Heart16Regular,
  Heart24Regular,
  Key16Regular,
  Key24Regular,
  LockClosed16Regular,
  LockClosed24Regular,
  Server16Regular,
  Server24Regular,
  Shield16Regular,
  Shield24Regular,
  Star16Regular,
  Star24Regular,
} from '@/components/Icon'

export const workspaceIconPackC = {
  bookmark: { 16: Bookmark16Regular, 24: Bookmark24Regular },
  star: { 16: Star16Regular, 24: Star24Regular },
  heart: { 16: Heart16Regular, 24: Heart24Regular },
  shield: { 16: Shield16Regular, 24: Shield24Regular },
  lock: { 16: LockClosed16Regular, 24: LockClosed24Regular },
  key: { 16: Key16Regular, 24: Key24Regular },
  cloud: { 16: Cloud16Regular, 24: Cloud24Regular },
  database: { 16: Database16Regular, 24: Database24Regular },
  server: { 16: Server16Regular, 24: Server24Regular },
  desktop: { 16: Desktop16Regular, 24: Desktop24Regular },
}
